import { FC } from 'react';
import { AllieLinkProps } from './Link.types';
import { IonIcon } from '@ionic/react';
import { StyledLink } from './Link.styles';

export const AllieLink: FC<AllieLinkProps> = ({
  disabled = false,
  allieSize = 'normal',
  iconPosition = 'right',
  icon,
  children,
  ...props
}) => {
  const sizeMapping = {
    normal: 'large',
    medium: 'default',
    small: 'small',
    xs: 'xs',
    none: 'none',
  };

  const renderChildren = () => (
    <>
      {icon && iconPosition === 'left' && <IonIcon icon={icon} slot="start" />}
      {icon && iconPosition === 'right' && <IonIcon icon={icon} slot="end" />}
      {icon && iconPosition === 'center' && <IonIcon icon={icon} slot="icon-only" />}
      <span>{children}</span>
    </>
  );

  return (
    <StyledLink size={sizeMapping[allieSize] as any} disabled={disabled} {...props}>
      {renderChildren()}
    </StyledLink>
  );
};
